import { Grid, Section } from '@cmg/design-system';
import {
  FormikAutocompleteField,
  FormikTextField,
  parseFormikValueToSelectOption,
  parseSelectOptionToFormikValue,
} from '@cmg/design-system-formik';
import { xcSelectors } from '@cmg/e2e-selectors';
import { useFormikContext } from 'formik';
import React from 'react';

import { OfferingType } from '../../../../graphql';
import {
  CONVERTIBLE_SECURITY_TYPE_OPTIONS,
  PP_SECURITY_TYPE_OPTIONS,
  SECURITY_TYPE_OPTIONS,
  securityShareClassOptions,
} from '../../../../types/domain/security/constants';
import type { FormType } from '../BasicInfoForm.model';

export type Props = {
  submitting?: boolean;
};

const getSecurityTypeOptions = (offeringType: OfferingType) => {
  if (offeringType === OfferingType.Convertible) {
    return CONVERTIBLE_SECURITY_TYPE_OPTIONS;
  }
  if (offeringType === OfferingType.PrivatePlacement) {
    return PP_SECURITY_TYPE_OPTIONS;
  }
  return SECURITY_TYPE_OPTIONS;
};

/**
 * A reusable subsection of Fields for Formik forms
 * Used by BasicInfoForm & CreateOfferingForm
 */
export const SecuritySubForm: React.FC<Props> = ({ submitting }) => {
  const { values } = useFormikContext<FormType>();
  const isConvertible = values.type === OfferingType.Convertible;
  const isPrivatePlacement = values.type === OfferingType.PrivatePlacement;

  return (
    <Section title="Security">
      <Grid container direction="row" item spacing={2}>
        <Grid item md={3} sm={6} xs={12}>
          <FormikAutocompleteField
            data-testid={xcSelectors.offeringSetupBasicInfoSecurityType.testId}
            name="security.type"
            label="Security Type"
            placeholder="Choose Type..."
            required
            parseFormikValue={parseFormikValueToSelectOption}
            parseToFormikValue={parseSelectOptionToFormikValue}
            disabled={submitting}
            options={getSecurityTypeOptions(values.type)}
          />
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          {isConvertible || isPrivatePlacement ? (
            <FormikTextField
              label="Security Description"
              name="security.securityDescription"
              disabled={submitting}
            />
          ) : (
            <FormikAutocompleteField
              data-testid={xcSelectors.offeringSetupBasicInfoShareClass.testId}
              name="security.shareClass"
              label="Security Description"
              placeholder="Choose Security Description..."
              disabled={submitting}
              options={securityShareClassOptions}
              parseFormikValue={parseFormikValueToSelectOption}
              parseToFormikValue={parseSelectOptionToFormikValue}
            />
          )}
        </Grid>
      </Grid>
    </Section>
  );
};

export default SecuritySubForm;
